import { useState } from 'react';
import { Boxes } from 'lucide-react';
import { useWaapApiCharts, API_TIME_RANGES, type ApiTimeRange } from '@/api/waap';
import { useWaapWebsite } from '@/pages/services/waap/waap-context';
import { WaapAnalyticsBoard } from './WaapAnalyticsBoard';

/**
 * Analytics → API — NATIVE charts (Superset dashboard 60) rendered through the
 * shared board shell. This board has NO Domain filter (only Time Range), so the
 * `domains` props are omitted.
 */
export function ApiAnalyticsTab() {
  const { selected } = useWaapWebsite();
  const [range, setRange] = useState<ApiTimeRange>('Last 24 Hours');
  const query = useWaapApiCharts(selected?.domainId, range);
  return (
    <WaapAnalyticsBoard
      icon={<Boxes size={26} />}
      label="API"
      ranges={API_TIME_RANGES}
      range={range}
      onRangeChange={setRange}
      query={query}
    />
  );
}
